import React, { useEffect } from 'react';
import { useHistory, withRouter } from "react-router-dom";
import { connect } from 'react-redux';

const WorkInProgress = (props) => {
    const history = useHistory();

    useEffect(() => {
        if (props.token && props.token != "" && props.token != null && props.userEntryType != "") {
            if (props.userCredentials && props.userCredentials.user_details && props.userCredentials.user_details.user_type && props.userCredentials.user_details.user_type == "app_admin") {
                history.push(`/${localStorage.getItem('i18nextLng')}/home/organisation`);
            } else {
                if (props.userCredentials.user_details.user_type == "admin") {
                    const isSubscribed = props.userCredentials.user_details?.is_subscribed;
                    if (isSubscribed) {
                        history.push(`/${localStorage.getItem('i18nextLng')}/user/user`);
                    } else {
                        history.push(`/${localStorage.getItem('i18nextLng')}/settings/stores`);
                    }

                } else {
                    let rolePermissions = props.userCredentials.user_details?.role_permission;
                    if (typeof rolePermissions === "string") {
                        try {
                            rolePermissions = JSON.parse(rolePermissions);
                        } catch (e) {
                            console.error("Invalid JSON in role_permission");
                            rolePermissions = [];
                        }
                    }
                    let permissionHash = {};
                    rolePermissions?.forEach((value) => {
                        permissionHash[value.eventKey] = value;
                    });
                    const firstPermissionRoute = roleWiseTabSelectedPermission(permissionHash);
                    if (firstPermissionRoute) {
                        history.push(`/${localStorage.getItem('i18nextLng')}/${firstPermissionRoute}`);
                    } else {
                        history.push(`/${localStorage.getItem('i18nextLng')}/user/user`);
                    }
                }
            }
        } else {
            history.push(`/${localStorage.getItem('i18nextLng')}/login`);
        }
    }, [])

    const roleWiseTabSelectedPermission = (roleWisePermission) => {
        const subEventToRouteMap = {
            "master_dashboard": "dashboard",
            "billing_counter_dashboard": "billing-counter-dashboard",
            // "purchase_orders": "sales/sales/purchase-orderss",
            "purchase_orders": "sales/purchase-orders",
            "invoices": "sales/invoices",
            "orders": "sales/orders",
            "digital_menu_orders": "sales/digital-menu-orders",
            "quotations": "sales/quotations",
            "transactions": "sales/transactions",
            "accounts": "business/accounts",
            "monthly_targets": "business/monthly-targets",
            "business_registers": "business/registers",
            "users": "user/user",
            "customers": "users/customers",
            "roles": "user/role",
            "suppliers": "supplier",
            "tax_codes": "tax-codes",
            "discount_codes": "tax-discount/discount-codes",
            "products": "stock/products",
            "categories": "category",
            "stock_transfer": "stock/transfer",
            "stock_return": "stock/return",
            "product_label": "stock/product-label",
            "add_on_groups": "stock/addon-groups",
            "bookings_and_events": "bookings/events",
            "calendar": "bookings/calendar",
            "download_reports": "reports/download",
            "best_seller_report": "reports/best-seller",
            "day_wise_sale_report": "reports/day-wise-sale",
            "category_report": "reports/category",
            "stock_quantity_alert": "reports/stock-alert",
            "store_stock_chart": "reports/store-stock-chart",
            "kitchen_display": "restaurant/kitchen-display",
            "waiter_display": "restaurant/waiter-display",
            "tables": "restaurant/tables",
            "restaurant_menu": "restaurant/menu",
            "notifications": "notification/list",
            "import_data": "import/data",
            "upload_users": "import/upload-update",
            "stores": "settings/stores",
            "payment_methods": "settings/payment-methods",
            "billing_counters": "settings/billing-counters",
            "email_settings": "settings/email",
            "sms_settings": "settings/sms",
            "sms_templates": "settings/sms-templates",
            "measurement_units": "settings/measurement-units",
            "variant_options": "settings/variant-options",
            "printers": "settings/printers",
            "kitchen_displays": "settings/kitchen-displays",
            "app_settings": "settings/app"
        };

        for (const key in roleWisePermission) {
            const module = roleWisePermission[key];
            if (Array.isArray(module.subeventKey)) {
                for (const sub of module.subeventKey) {
                    if (sub.rules && sub.rules !== "") {
                        const mapped = subEventToRouteMap[sub.eventKey] || sub.eventKey;
                        return mapped;
                    }
                }
            }
            if (module.rules && module.rules !== "") {
                const mapped = subEventToRouteMap[module.eventKey] || module.eventKey;
                return mapped;
            }
        }
        return null;
    };

    const goToHome = () => {
        history.push(`/${localStorage.getItem('i18nextLng')}/dashboard`);
    }

    return (
        <div style={{
            margin: 0,
            padding: 0,
            fontFamily: 'Arial, sans-serif',
            backgroundColor: '#f8f9fa',
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center'
        }}>
            <div style={{ padding: '20px' }}>
                <div style={{
                    fontSize: '60px',
                    color: '#007bff',
                    animation: 'spin 2s linear infinite'
                }}>⚙️</div>

                <h1 style={{ marginTop: '20px', fontSize: '32px', color: '#333' }}>
                    Work in Progress
                </h1>
                <p style={{ fontSize: '18px', color: '#555' }}>
                    We're currently working on this page. Please check back later.
                </p>
                <button style={{
                    border: '1px solid #000',
                    backgroundColor: 'transparent',
                    fontSize: ' 13px',
                    padding: '4px 10px',
                    borderRadius: '4px'
                }} onClick={() => { goToHome() }}>Go to home</button>

                {/* Keyframe animation inside a style tag */}
                <style>
                    {`@keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
          }`}
                </style>
            </div>
        </div>
    );
};

// export default WorkInProgress;
const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials,
        userEntryType: globalState.LoginReducer.userEntryType,
        token: globalState.LoginReducer.token,
    };
}


export default connect(mapStateToProps, {})(withRouter(WorkInProgress));

